// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"0cf0c759","1073":"0cf0c759","2416":"dee67317","2708":"be5cb0ee","2838":"6b2c23af","3087":"0cf0c759","3598":"c9c94bbe","4684":"0cf0c759","5611":"c9c94bbe","5905":"0cf0c759","8273":"0cf0c759","9970":"9fc3a03b"}[chunkId] + ".chunk.css";
};